module.exports = __webpack_public_path__ + "static/media/github.c51617ae.jpg";